if (!customElements.get('side-panel-tabs-links')) {
  class SidePanelTabsLinks extends HTMLElement {
    constructor() {
      super();
      this.link = this.querySelector('button');
    }

    connectedCallback() {
      this.setupObserver();
    }

    setupObserver() {
      const id = this.link.dataset.id;
      const drawer = document.querySelector(id);

      this.link.addEventListener('click', () => {
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
      });
    }
  }

  customElements.define('side-panel-tabs-links', SidePanelTabsLinks);
}
